import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import BaseModal from 'components/Modals/BaseModal'
import { Alert } from 'ui'
import { Button } from 'components/Forms'
import { getRoutes, extractFavorites } from 'services/Utilities'
import { closeModal } from 'store/actions/modals'
import { updateSetting } from 'store/actions/settings'
import { ButtonGroup, List } from 'ui'

import { t } from 'translations'

const ManagerNavFavoritesModal = () => {
  const dispatch = useDispatch()
  const { managerNavFavorites } = useSelector(state => state.settings)
  const [isSubmitting, setIsSubmitting] = useState()
  const [newFavorites, setNewFavorites] = useState(managerNavFavorites)

  const sortedRoutes = getRoutes('manager', true)

  const { favoriteRoutes, otherRoutes } = extractFavorites(sortedRoutes, newFavorites)

  const saveFavorites = async favorites => {
    setIsSubmitting(true)
    await dispatch(updateSetting('managerNavFavorites', favorites))
    dispatch(closeModal())
  }

  const moveInArray = (array, index, direction) => {
    array.splice(index + direction, 0, array.splice(index, 1)[0])
    return [...array]
  }

  return (
    <BaseModal hideButtons title={`manager.NAV.FAVORITES_MODAL`}>
      <Alert variant="warning" className="my-2" show={!!(favoriteRoutes.length > 5)}>
        {t('manager.NAV.FAVORITES_MODAL.TOO_MANY_FAVORITES')}
      </Alert>
      <List className="my-2">
        {favoriteRoutes.map((route, index) => (
          <List.Item key={route.title}>
            <div className="d-flex">
              <span className="pr-1">
                <i className={`fad fa-${route.icon}`} />
              </span>{' '}
              {t(`manager.${route.title}`)}
              <div className="ml-auto">
                <ButtonGroup>
                  <Button className="btn btn-outline-secondary" onClick={() => setNewFavorites(moveInArray(newFavorites, index, -1))} disabled={index === 0}>
                    <i className="fas fa-arrow-up" />
                  </Button>
                  <Button
                    className="btn btn-outline-secondary"
                    onClick={() => setNewFavorites(moveInArray(newFavorites, index, 1))}
                    disabled={index === favoriteRoutes.length - 1}
                  >
                    <i className="fas fa-arrow-down" />
                  </Button>
                  <Button
                    className="btn btn-outline-secondary"
                    text="actions.REMOVE"
                    onClick={() => setNewFavorites(newFavorites.filter(title => title !== route.title))}
                  />
                </ButtonGroup>
              </div>
            </div>
          </List.Item>
        ))}
      </List>
      <List>
        {otherRoutes.map(route => (
          <List.Item key={route.title}>
            <div className="d-flex">
              <span className="pr-1">
                <i className={`fad fa-${route.icon}`} />
              </span>{' '}
              {t(`manager.${route.title}`)}
              <div className="ml-auto">
                <Button className="btn btn-outline-secondary" text="actions.ADD" onClick={() => setNewFavorites([...newFavorites, route.title])} />
              </div>
            </div>
          </List.Item>
        ))}
      </List>
      <div className="mt-2">
        <Button text="actions.CONFIRM" isSubmitting={isSubmitting} className="btn btn-primary mr-2" onClick={() => saveFavorites(newFavorites)} />
        <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
      </div>
    </BaseModal>
  )
}

export default ManagerNavFavoritesModal
